import GlobalSearch from './GlobalSearch'
export default GlobalSearch



// WEBPACK FOOTER //
// ./src/components/GlobalSearch/index.js